/* eslint-disable react-hooks/rules-of-hooks */
import { isAdminDomain, isPartnerDomain, isSupportDomain } from '../../lib/currentDomain'
import {
    useCompanyGetLoadbalancerGroupsPagedQuery,
    usePartnerGetLoadbalancerGroupsPagedQuery,
    useLoadBalancerGroupGetAllPagedQuery,
    LoadBalancerGroupGetAllPagedApiArg,
    PagedResultOfLoadBalancerGroup,
    CompanyGetLoadbalancerGroupsPagedApiArg,
    usePartnerGetCompaniesByPartnerIdQuery,
    useCompanyGetAdministratedCompaniesQuery,
    Company,
    CompanyPreview,
    Alarm,
    usePartnerGetAlarmsByPartnerIdQuery,
    useAlarmGetAllQuery,
    NfcTag,
    usePartnerGetNfcTagsQuery,
    useCompanyGetNfcTagsQuery,
    useCompanyGetChargePointsPagedQuery,
    usePartnerGetChargePointsPagedQuery,
    ChargePoint,
    CompanyGetChargePointsPagedApiArg,
} from '../redux/api/web-api'

export const useLoadbalancerGroupsQuery = (
    partnerId: number,
    companyId: string,
    filter: LoadBalancerGroupGetAllPagedApiArg | CompanyGetLoadbalancerGroupsPagedApiArg
): { data?: PagedResultOfLoadBalancerGroup | undefined | null; isFetching: boolean; refetch: () => void } => {
    if (isAdminDomain) {
        return useCompanyGetLoadbalancerGroupsPagedQuery({ companyId, ...filter })
    }
    if (isPartnerDomain) {
        return usePartnerGetLoadbalancerGroupsPagedQuery({ partnerId, ...filter })
    }
    if (isSupportDomain) {
        return useLoadBalancerGroupGetAllPagedQuery({ ...filter })
    }
    return {
        data: undefined,
        isFetching: false,
        refetch: () => {},
    }
}

export const useCompanyQuery = (
    partnerId?: number
): { data?: Company[] | CompanyPreview[] | undefined | null; isFetching: boolean; refetch: () => void } => {
    if (isPartnerDomain) {
        return usePartnerGetCompaniesByPartnerIdQuery({ partnerId: partnerId! }, { skip: !partnerId })
    }
    if (isSupportDomain) {
        return useCompanyGetAdministratedCompaniesQuery()
    }
    return {
        data: undefined,
        isFetching: false,
        refetch: () => {},
    }
}

export const useAlarmQuery = (partnerId?: number, showConfirmed?: boolean): { data?: Alarm[]; isLoading: boolean } => {
    if (isPartnerDomain) {
        return usePartnerGetAlarmsByPartnerIdQuery(
            { expand: 'company', partnerId: partnerId!, showConfirmed, noOfItems: 100 },
            { skip: !partnerId }
        )
    }
    if (isSupportDomain) {
        return useAlarmGetAllQuery({ noOfItems: 1000, expand: 'company' })
    }
    return {
        data: undefined,
        isLoading: false,
    }
}

export const useRFIDTagsQuery = (
    partnerId?: number,
    companyId?: string
): { data?: NfcTag[] | undefined; isLoading: boolean } => {
    if (isAdminDomain) {
        return useCompanyGetNfcTagsQuery({ companyId: companyId! }, { skip: !companyId })
    }
    if (isPartnerDomain) {
        return usePartnerGetNfcTagsQuery({ partnerId: partnerId! }, { skip: !partnerId })
    }
    return {
        data: undefined,
        isLoading: false,
    }
}

export const useChargePointsQuery = ({
    partnerId,
    companyId,
    ...options
}: CompanyGetChargePointsPagedApiArg): {
    data?: { items?: ChargePoint[] | null; totalCount?: number; pageSize?: number | null; pageIndex?: number | null }
    isLoading: boolean
} => {
    if (isAdminDomain) {
        return useCompanyGetChargePointsPagedQuery({ companyId: companyId!, ...options }, { skip: !companyId })
    }
    if (isPartnerDomain) {
        return usePartnerGetChargePointsPagedQuery({ partnerId: partnerId!, ...options }, { skip: !partnerId })
    }
    return {
        data: { items: null, totalCount: 0, pageSize: null, pageIndex: null },
        isLoading: false,
    }
}
